import React from 'react';
import Footer from '../../molecules/Footer';
import Header from '../../molecules/Header';

/**
 * メール配信設定 システムメンテナンス画面
 */
const SystemMaintenancePage: React.FC = () => {
  return (
    <div>
      <Header />
      <div className='md-container'>
        <h2 className='md-headline'>ご利用ありがとうございます。</h2>
        <p className='md-text'>
          システムメンテナンス中です。
          <br />
          ８：００以降にご利用ください。
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default SystemMaintenancePage;
